import { createContext } from 'react';

const SignContext = createContext();

export default SignContext;
